import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as enums from '../enums'

const DOC = gql`
  query RoomTypes($tenantId: ID!, $zoneId: ID!, $appId: ID!, $scenarioId: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                roomTypes {
                  id
                  code
                  name
                  description
                  category
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.RoomTypesQuery,
    ents.extra.space.RoomType[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'roomTypes',
                graphql.transformers.OUT.list(
                  graphql.transformers.OUT.object({
                    category: graphql.transformers.OUT.validate(
                      enums.category.TRANSFORMER,
                      TypeAsserter.assertIsNotNullish,
                    ),
                    code: transformers.PASS_THROUGH,
                    description: transformers.PASS_THROUGH,
                    id: graphql.transformers.OUT.validate(
                      transformers.PASS_THROUGH,
                      ents.extra.space.RoomType.Id.isId,
                    ),
                    name: transformers.PASS_THROUGH,
                  }),
                  { onNullish: 'remove' },
                ),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.RoomTypesQuery,
  ents.extra.space.RoomType[],
  graphql.schema.RoomTypesQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
